import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import Image from "next/image";
import { useCallback, useEffect, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function ProgressCircle() {
  var circle = useRef();
  useEffect(function () {
    if (circle.current) {
      circle.current.style["stroke-dashoffset"] = 0;
    }
  }, [circle.current]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.progressCircle,
    children: /*#__PURE__*/_jsxs("svg", {
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("circle", {
        r: "45",
        cx: "50",
        cy: "50",
        fill: "transparent",
        strokeDasharray: "282.6",
        strokeDashoffset: "0",
        strokeOpacity: "0.5"
      }), /*#__PURE__*/_jsx("circle", {
        ref: circle,
        r: "45",
        cx: "50",
        cy: "50",
        fill: "transparent",
        strokeDasharray: "282.6",
        strokeDashoffset: "0"
      })]
    })
  });
}

export default function NextEpisode(_ref) {
  var watch = _ref.watch,
      state = _ref.state;
  var nextEpisode = watch.nextEpisode;
  var handleCancel = useCallback(function () {
    state.prepareSuspend();
  }, []);
  var pageTransition = useCallback(function () {
    window.location.href = routes.watch(nextEpisode.id);
  }, []);
  useEffect(function () {
    var timeoutId = setTimeout(function () {
      pageTransition();
    }, 15000);
    return function () {
      clearTimeout(timeoutId);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.nextEpisode,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          onClick: pageTransition,
          children: "\u6B21\u306E\u30A8\u30D4\u30BD\u30FC\u30C9\u3092\u898B\u308B"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.episode,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.episode,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.artwork,
            children: /*#__PURE__*/_jsx(Image, {
              src: nextEpisode.thumbnailUrl,
              alt: nextEpisode.name,
              width: 160,
              height: 90,
              layout: "responsive"
            })
          })
        }), /*#__PURE__*/_jsx(ProgressCircle, {})]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: /*#__PURE__*/_jsx("span", {
          children: nextEpisode.name
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          className: styles.cancel,
          onClick: handleCancel,
          children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
        })
      })]
    })
  });
}